import React from "react";
import { Box, Container, Divider, Stack, Typography } from "@mui/material";
import { graphql } from "gatsby";
import { PortableText } from "@portabletext/react";
import NavigationWrapper from "../components/layout/NavigationWrapper";
import SEO from "../components/Seo";
import COLORS from "../constants/colors";
import UseIsMobile from "../hooks/useIsMobile";
import {
  BlockContent,
  SanityPostData,
} from "../interfaces/sanity/sanityClasses";
import PostImage from "../components/sanity/PostImage";

export const query = graphql`
  query MyQuery {
    personvern: sanityPageContent(
      id: { eq: "-11405044-bc6e-5a4f-9478-24ee3cffff7d" }
    ) {
      title
      _rawBody
    }
    cookies: sanityPageContent(
      id: { eq: "-e9f278d4-7cc4-5cf4-b0f3-8aba2e6a44c7" }
    ) {
      title
      _rawBody
    }
  }
`;

const components = {
  listItem: {
    // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
    bullet: ({ children }: any) => (
      <li style={{ color: COLORS.BLACK["100"] }}>
        <Typography color="dark.dark" variant="body">
          {children}
        </Typography>
      </li>
    ),
  },
  block: {
    // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
    normal: ({ children }: any) => {
      if (children[0] === "<button-innstillinger>") {
        return (
          // eslint-disable-next-line react/button-has-type
          <Box pt="20px">
            <button id="ot-sdk-btn" className="ot-sdk-show-settings">
              Informasjonskapsel-innstillinger
            </button>
          </Box>
        );
      }
      if (children[0] === "<ot-sdk-cookie-policy>") {
        return <div id="ot-sdk-cookie-policy" />;
      }
      return (
        <Typography color="primary" variant="body" paragraph>
          {children}
        </Typography>
      );
    },
    // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
    h1: ({ children }: any) => (
      <Typography
        color="primary"
        variant="h1"
        pt={{ xs: "24px", md: "48px" }}
        pb={{ xs: "12px", md: "24px" }}
      >
        {children}
      </Typography>
    ),
    // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
    h2: ({ children }: any) => (
      <Typography
        color="primary"
        variant="h2"
        pt={{ xs: "24px", md: "48px" }}
        pb={{ xs: "12px", md: "24px" }}
      >
        {children}
      </Typography>
    ),
    // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
    h3: ({ children }: any) => (
      <Typography
        color="primary"
        variant="h3"
        pt={{ xs: "24px", md: "48px" }}
        pb={{ xs: "12px", md: "24px" }}
      >
        {children}
      </Typography>
    ),
    // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
    h4: ({ children }: any) => (
      <Typography
        color="primary"
        variant="h4"
        pt={{ xs: "12px", md: "24px" }}
        pb={{ xs: "6px", md: "12px" }}
      >
        {children}
      </Typography>
    ),
  },
  types: {
    // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
    image: (props: any) => <PostImage title="" {...props} />,
  },
};
const PrivacyPage = ({ data }: SanityPostData) => {
  const isMobile = UseIsMobile();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { _rawBody, title }: BlockContent =
    // eslint-disable-next-line react/destructuring-assignment
    data.personvern;

  return (
    <NavigationWrapper>
      <div style={{ backgroundColor: COLORS.WHITE["100"] }}>
        <Container>
          <Stack gap="48px" pb="80px" pt="80px" maxWidth="727px">
            <Stack>
              <Typography color={COLORS.DARK_BLUE[100]} variant="h1">
                {title}
              </Typography>
            </Stack>
            <Stack>
              <PortableText value={_rawBody} components={components} />
            </Stack>
            <Divider />
            <Stack>
            <Typography color={COLORS.DARK_BLUE[100]}  variant="h1">
                {data.cookies.title}
              </Typography>
            </Stack>
            <Stack pb={isMobile ? "10px" : "48px"}>
              <PortableText
                value={data.cookies._rawBody}
                components={components}
              />
            </Stack>
          </Stack>
        </Container>
      </div>
    </NavigationWrapper>
  );
};

export default PrivacyPage;

export function Head() {
  return (
    <SEO
      title="Personvernerklæring og informasjonskapsler - Horde"
      description="I Horde sin personvernerklæring kan du lese hvilke personopplysninger vi behandler, formålet med dette og hvordan vi ivaretar ditt personvern."
    />
  );
}
